module.exports = __webpack_public_path__ + "img/drag-n-drop2.6ab9427b.svg";